import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Switch,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DEMO_MODE_KEY, HIDE_LOGO_KEY } from "../constants";

interface DemoSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  hideLogo: boolean;
  demoMode: boolean;
  onHideLogoChange: (value: boolean) => void;
  onDemoModeChange: (value: boolean) => void;
}

const DemoSettingsDialog: React.FC<DemoSettingsDialogProps> = ({
  open,
  onClose,
  hideLogo,
  demoMode,
  onHideLogoChange,
  onDemoModeChange,
}) => {
  const handleHideLogoToggle = () => {
    const newValue = !hideLogo;
    onHideLogoChange(newValue);
    localStorage.setItem(HIDE_LOGO_KEY, String(newValue));
  };

  const handleDemoModeToggle = () => {
    const newValue = !demoMode;
    onDemoModeChange(newValue);
    localStorage.setItem(DEMO_MODE_KEY, String(newValue));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Demo Settings
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          <Box>
            <FormControlLabel
              control={
                <Switch checked={hideLogo} onChange={handleHideLogoToggle} />
              }
              label="Hide Logo"
            />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 6 }}>
              Hides the logo in the top navigation bar
            </Typography>
          </Box>
          <Box>
            <FormControlLabel
              control={
                <Switch checked={demoMode} onChange={handleDemoModeToggle} />
              }
              label="Demo Mode"
            />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 6 }}>
              Shows demo data instead of real data
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DemoSettingsDialog;
